<div class="modal-header">
  <h3>Change VIVE Status</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  <div class="form-group">
    <label class="form-label" requiredAsterisk>Status</label>
    <select
      class="form-select"
      (change)="onCompanyStatusChange()"
      [(ngModel)]="status"
    >
      @for (status of companyStatuses; track status) {
        <option [ngValue]="status">
          {{ status }}
        </option>
      }
    </select>
  </div>

  <div class="form-group">
    <label class="form-label" requiredAsterisk>Title</label>
    <input
      type="text"
      class="form-control"
      [disabled]="true"
      [(ngModel)]="noteTitle"
    />
  </div>

  <div class="form-group">
    <label class="form-label" requiredAsterisk>Note</label>
    <textarea class="form-control" rows="5" [(ngModel)]="note"></textarea>
  </div>
</div>
<div class="modal-footer">
  <div class="row w-100 justify-content-end">
    <div class="col-3">
      <button class="btn btn-danger" (click)="close()">Close</button>
    </div>
    <div class="col-3">
      <button class="btn btn-primary" (click)="save()">Save</button>
    </div>
  </div>
</div>
